import { Box, Typography } from '@mui/material';
import MuiAccordionDetails from '@mui/material/AccordionDetails';

import { useTranslation } from 'react-i18next';

import Accordion from '../../../../../../common/components/accordion/Accordion';
import AccordionSummary from '../../../../../../common/components/accordion/AccordionSummary';
import ImpactDescriptionInput from './ImpactDescriptionInput';

import { useCollapse } from '../../../../../../common/hooks/useCollapse';

const ProofOfEffectivenessSection = ({ ncr, loading, handleUpdate }) => {
    const { t } = useTranslation();

    const [expanded, collapse] = useCollapse(true);

    return (
        <Box style={{ borderRadius: 16 }}>
            <Accordion disableGutters elevation={3} sx={{ width: '100%', padding: '1.5em' }} expanded={expanded} onChange={collapse}>
                <AccordionSummary>
                    <Typography variant="h6" noWrap component="div">
                        {t('ncrInfo.valuation.proofOfEffectiveness')}
                    </Typography>
                </AccordionSummary>
                <MuiAccordionDetails sx={{ padding: '1em 0' }}>
                    <ImpactDescriptionInput value={ncr?.impactDescription} disabled={loading} handleUpdate={handleUpdate} />
                </MuiAccordionDetails>
            </Accordion>
        </Box>
    );
};

export default ProofOfEffectivenessSection;
